import React from 'react'
import PropTypes from 'prop-types'
import {sankeyLinkHorizontal} from 'd3-sankey'

class Link extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    width: PropTypes.number
  }

  state = {isMouveOver: false}

  render() {
    const link = sankeyLinkHorizontal()
    const {data, width} = this.props
    return (
      <g
        className='sankey-chart_link'
      >
        <defs>
          <linearGradient
            id={`gradient-${data.index}`}
            gradientUnits='userSpaceOnUse'
            x1={data.source.x1}
            x2={data.target.x0}
          >
            <stop offset='0' stopColor='#bfc8cf' />
            <stop offset='100%' stopColor='#eef1f4' />
          </linearGradient>
        </defs>
        <path
          d={link(data)}
          fill={'none'}
          stroke={`url(#gradient-${data.index})`}
          strokeOpacity={0.5}
          strokeWidth={width}
        />
      </g>
    )
  }
}
export default Link



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/SankeyChart/Link.js